import { Service } from 'typedi';
import { BaseService, IBaseService, ServerResponse } from '../../../core/services/BaseService';
import { Appl } from '../../../core/Appl';
import { CaseStatusLookupForm } from './lookup/CaseStatusModel';

export interface ICaseStatusService extends IBaseService {
  lookupCaseStatusAsync(form: CaseStatusLookupForm): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class CaseStatusService extends BaseService implements ICaseStatusService {
  constructor() {
    super(`${Appl.Setting.Services.BeneverseServiceUrl}`);
  }

  public async lookupCaseStatusAsync(form: CaseStatusLookupForm): Promise<ServerResponse> {
    try {
      const response = await this.client.post('/beneverse/member-portal/case-status', form);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
}
